module.exports = __webpack_public_path__ + "static/media/รายงานปรับสภาพหนี้.3a115cd2.xls";